import { useEffect, useRef } from "react";
import { Chart } from "chart.js/auto";
import { defaultColors } from "../../datas/colors";

export default function PieChart({title, labels, values, colors = defaultColors}) {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }

    const ctx = chartRef.current.getContext("2d");
    chartInstance.current = new Chart(ctx, {
      type: "pie",
      data: {
        labels: labels,
        datasets: [
          {
            label: "citações",
            data: values,
            backgroundColor: colors,
            borderWidth: 0,
            pointRadius: 20,
            pointBackgroundColor: "#3b82f6",
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'bottom'
          },
          tooltip: {
            enabled: true,
            backgroundColor: "#ffffff", // Fundo branco
            titleColor: "#333333", // Cor do título mais escura para melhor leitura
            titleFont: { weight: "bold", size: 14 }, // Fonte do título mais destacada
            bodyColor: "#444444", // Cor do corpo (habilidade + descrição)
            bodyFont: { size: 13 }, // Tamanho da fonte do corpo
            footerColor: "#1565C0", // Azul mais sofisticado para o footer
            footerFont: { weight: "bold", size: 12 }, // Fonte do footer destacada
            borderColor: "#DDDDDD", // Borda cinza clara
            borderWidth: 1,
            cornerRadius: 10, // Cantos mais arredondados
            padding: 12, // Mais espaço para melhor visualização
            displayColors: false,
          },
        },
        // scales: {
        //   r: {
        //     angleLines: {
        //       color: "#e5e7eb",
        //     },
        //     grid: {
        //       color: "#e5e7eb",
        //     },
        //     pointLabels: {
        //       font: {
        //         size: 12,
        //         weight: "bold",
        //       },
        //       color: "#374151",
        //     },
        //     ticks: {
        //       display: false,
        //     },
        //   },
        // },
      },
    });

    return () => chartInstance.current.destroy();
  }, []);

  return (
    <div className="p-6 bg-white shadow-md rounded-lg border w-full border-gray-200">
      <h2 className="text-lg font-bold">{title}</h2>
      <p className="text-gray-500">1998 - 2023</p>
      <div className="relative w-full h-72">
        <canvas ref={chartRef}></canvas>
      </div>
      {/* <p className="text-sm text-gray-600 mt-3 font-semibold">
        Trending up by 5.2% this month 📈
      </p>
      <p className="text-xs text-gray-400">January - June 2024</p> */}
    </div>
  );
}
